import { FC } from "react";
import { AgentNewThreadMessage } from "winslow-core";
import "./NewThreadMessage.css";
import { useMessageThreadInfo } from "../../hooks/useMessageThreadInfo";
import { MessageThreadType } from "winslow-core";
import { ThreadInfo } from "./ThreadInfo";
import { useDispatch } from "react-redux";
import { openEmployeeProfileSidebar } from "../../redux/features/agent/agentSlice";

interface NewThreadMessageProps {
  message: AgentNewThreadMessage;
}

export const NewThreadMessage: FC<NewThreadMessageProps> = ({ message }) => {
  const dispatch = useDispatch();
  const contextInfo = useMessageThreadInfo(message.thread);

  const handleThreadInfoClick = (employeeId?: string) => {
    if (employeeId) {
      dispatch(openEmployeeProfileSidebar({ employeeId }));
    }
  };

  if (!contextInfo) {
    return null;
  }

  return (
    <div className="agent-chat-history-item">
      <div className="new-thread-message">
        <div className="new-thread-divider"></div>

        {contextInfo.threadType === MessageThreadType.NONE && (
          <ThreadInfo
            showAvatar={false}
            label="Removed Context"
            className="centered"
          />
        )}

        {contextInfo.threadType === MessageThreadType.PERSONA && (
          <ThreadInfo
            showAvatar={true}
            avatar={contextInfo.avatar}
            label={contextInfo.label || "Persona Context Changed"}
            className="centered"
          />
        )}

        {contextInfo.threadType === MessageThreadType.EMPLOYEE && (
          <ThreadInfo
            showAvatar={true}
            avatar={contextInfo.avatar}
            label={contextInfo.label || "Employee Context Changed"}
            className="centered"
            onClick={handleThreadInfoClick}
            employeeId={contextInfo.employeeId}
            clickable={!!contextInfo.employeeId}
          />
        )}
      </div>
    </div>
  );
};
